const DeathgardenPage = () => {
  return (
    <div>DeathgardenPage</div>
  )
}

export default DeathgardenPage